import React from "react";
import { useDispatch, useSelector } from "react-redux";
import "./CommandesViewContent.css";
import { useTranslation } from "react-i18next";
import moment from "moment";
import VerticalPoints from "../Common/VerticalPoints/VerticalPoints";
import DataTable from "../Table/DataTable";
import {
  addCurrentAvoir,
  deleteAvoir,
  downloadInvoice,
  fetchAvoirs,
  generateInvoice,
} from "../../REDUX/actions/avoir";
import { formatCurrency } from "../../Utils";
import { useNavigate } from "react-router-dom";
import { openCenteredModal } from "../../REDUX/actions/centeredModal";
import ConfirmModal from "../Common/Modal/ConfirmModal";
import UpdateStatusDialog from "../Avoir/UpdateStatusDialog";
import { IMAGE_END_POINT } from "../../Api/EndPoints";
import { Spinner } from "react-bootstrap";
import UpdateCommentDialog from "../Avoir/UpdateComment";

const CommandesCreditsViewContent = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { avoirs, avoirLoading, loading, pageCount, total } = useSelector(
    (state) => state.avoirReducer,
  );

  const headers = [
    "N°",
    "Invoice Date",
    "Credit No.",
    "Credit Date",
    "Order No.",
    "Client",
    "Manager",
    "Credit Amount",
    "Status",
    "Created by",
  ];

  const columns = [
    {
      name: "N°",
      render: (row) => row?.attributes?.invoiceNumber ?? "-",
    },
    {
      name: "Invoice Date",
      render: (row) => {
        const date =
          row?.attributes?.attachment?.data?.attributes?.file?.data?.attributes
            ?.createdAt;
        return date ? moment(date).format("DD/MM/YYYY") : "-";
      },
    },
    {
      name: "Credit No.",
      render: (row) => row?.attributes?.number ?? "-",
    },
    {
      name: "Credit Date",
      render: (row) =>
        row?.attributes?.date
          ? moment(row?.attributes?.date).format("DD/MM/YYYY")
          : "-",
    },
    {
      name: "Order No.",
      render: (row) =>
        row?.attributes?.commande?.data?.attributes?.number ?? "-",
    },
    {
      name: "Client",
      render: (row) =>
        row?.attributes?.reseller?.data?.attributes?.name ??
        row?.attributes?.commande?.data?.attributes?.majorAccountName ??
        row?.attributes?.commande?.data?.attributes?.particulierName ??
        "-",
    },
    {
      name: "Manager",
      render: (row) =>
        row?.attributes?.businessAffiliate?.data?.attributes?.company ?? "-",
    },
    {
      name: "Credit Amount",
      render: (row) =>
        row?.attributes?.totalTTC
          ? formatCurrency(row?.attributes?.totalTTC)
          : "-",
    },
    {
      name: "Status",
      render: (row) =>
        row?.attributes?.status ? t(`${row?.attributes?.status}`) : "-",
    },
    {
      name: "Created by",
      render: (row) => {
        const firstName =
          row?.attributes?.creator?.data?.attributes?.firstName ?? "";
        const lastName =
          row?.attributes?.creator?.data?.attributes?.lastName ?? "";
        const fullName = [firstName, lastName].join(" ")?.trim();
        return fullName;
      },
    },
  ];

  headers.push("");
  columns.push({
    name: "options",
    render: (row) => {
      return (
        <VerticalPoints
          showLeft
          options={[
            {
              hidden: row?.attributes?.status === "Completed",
              text: t("Edit"),
              callback: async () => {
                dispatch(
                  addCurrentAvoir(row?.id, row?.attributes?.state, () =>
                    navigate("/avoirs/editer", {
                      state: { id: row?.id },
                    }),
                  ),
                );
              },
            },
            {
              text: t("Delete"),
              callback: () =>
                dispatch(
                  openCenteredModal(
                    <ConfirmModal
                      id={row?.id}
                      label={t("Credit")}
                      onConfirm={() => dispatch(deleteAvoir(row?.id, t))}
                    />,
                  ),
                ),
            },
            {
              text: t("Set status"),
              callback: () =>
                dispatch(
                  openCenteredModal(
                    <UpdateStatusDialog
                      id={row.id}
                      status={row?.attributes?.status}
                      number={row?.attributes?.number}
                    />,
                  ),
                ),
            },
            {
              text: t("Generate the credit"),
              callback: () => dispatch(generateInvoice(row?.id, t)),
            },
            {
              text: t("Download the credit"),
              hidden:
                !row?.attributes?.attachment?.data?.attributes?.file?.data
                  ?.attributes?.url,
              callback: () => {
                const file =
                  row?.attributes?.attachment?.data?.attributes?.file?.data;
                const url = `${IMAGE_END_POINT}${file?.attributes?.url}`;
                const fileName = file?.attributes?.name;
                dispatch(downloadInvoice(url, fileName, t));
              },
            },
            {
              text: t("Comment"),
              callback: () => {
                dispatch(
                  openCenteredModal(
                    <UpdateCommentDialog
                      id={row.id}
                      comment={row.attributes.comment}
                    />,
                  ),
                );
              },
            },
          ]}
        />
      );
    },
  });

  return (
    <div className="h-100 position-relative">
      {avoirLoading && (
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-50 z-9999 d-flex align-items-center justify-content-center">
          <Spinner />
        </div>
      )}
      <DataTable
        title={t("Credits")}
        titleClassName="text-blue bold f30 flex-2"
        headers={headers}
        columns={columns}
        fetchData={(page, search, _, signal) => {
          dispatch(fetchAvoirs(page, search, signal));
        }}
        totalPages={pageCount}
        data={avoirs}
        loading={loading}
        total={total}
        noResultsMessage="No results found"
        containerClassName="h-100 d-flex flex-column"
        showRowDetails
        view="credit"
      />
    </div>
  );
};

export default CommandesCreditsViewContent;
